import { Action } from "@web/route-services/chat/message/utils";
import { useAppContext } from "@web/route-services/root/AppContext";
import { motion } from "motion/react";
import React from "react";

interface Props {
  actions: Action[];
}

export function OptionsModal({ actions }: Props) {
  const { closeModal } = useAppContext();

  return (
    <div className="text-tx-primary flex h-fit max-h-96 w-full flex-col space-y-3 p-4">
      {actions.map((action) => (
        <React.Fragment key={action.label}>
          {action.show !== false && (
            <motion.button
              whileHover={{
                scale: 1.02,
                transition: { duration: 0.2 }
              }}
              whileTap={{
                scale: 0.95,
                transition: { duration: 0.005, ease: "easeOut" }
              }}
              onClick={() => {
                closeModal();
                action.onClick();
              }}
              className="border-line bg-button-secondary rounded-4xl flex items-center space-x-5 border-b px-5 py-3 shadow-sm"
            >
              <action.icon className="fill-tx-primary size-7" />
              <span className="text-tx-primary font-semibold">{action.label}</span>
            </motion.button>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
